//region :: Imports ::
import TooltipOptions from 'primereact/tooltip/tooltipoptions';
import {MouseEventHandler, ReactElement} from 'react';
import MComponent from '../Component';
import {classNames} from 'primereact/utils';
import {Button} from 'primereact/button';
import {evalulateBool, MBoolean} from './Control';

//endregion

/** */
export type MButtonColor = 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help';
export type MButtonSize = 'sm' | 'lg';
export type MButtonType = 'button' | 'submit' | 'reset';

/** */
export type MButtonRTProps = {
    label?: string;
    color?: MButtonColor;
    icon?: string;
    isBusy?: MBoolean;
}

/** */
type Props = MButtonRTProps & {
    type?: MButtonType;
    size?: MButtonSize;
    iconOnly?: boolean;
    tooltip?: string;
    tooltipOptions?: TooltipOptions;
    formId?: string;
    rounded?: boolean;
    outlined?: boolean;
    flat?: boolean;
    disabled: MBoolean;
    onClick?: MouseEventHandler<HTMLButtonElement>;
}

/** */
class MButton extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        const label = this.props.label === undefined ? '' : this.props.label;
        const type = this.props.type === undefined ? 'button' : this.props.type;
        const color = this.props.color === undefined ? 'primary' : this.props.color;
        const icon = this.props.icon === undefined ? undefined : `pi ${this.props.icon}`;
        const iconOnly = this.props.iconOnly;
        const size = this.props.size === undefined ? 'p-button' : `p-button-${this.props.size}`;
        const formId = this.props.formId;
        const isBusy = evalulateBool(this.props.isBusy);
        const disabled = isBusy || evalulateBool(this.props.disabled);
        const tooltipOptions = {...this.props.tooltipOptions, position: 'bottom'} as TooltipOptions;
        const classes = classNames(`p-button-raised p-button-${color} ${size} flex-1 md:flex-none`, {
            'p-button-text': this.props.flat === undefined ? false : this.props.flat,
            'p-button-rounded': this.props.rounded === undefined ? false : this.props.rounded,
            'p-button-outlined': this.props.outlined === undefined ? false : this.props.outlined
        });

        return (
            <Button className={classes}
                    label={iconOnly ? '' : label}
                    type={type}
                    icon={icon}
                    form={formId}
                    tooltip={this.props.tooltip}
                    tooltipOptions={tooltipOptions}
                    disabled={disabled}
                    loading={isBusy}
                    onClick={this.props.onClick}/>
        );

    }

}

export default MButton;
